import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core'
import {UserSessionService} from '../../../../services/user-session.service'
import {TitleService} from "../../../../services/title.service";
import {LocaleService} from "../../../../services/locale.service";
import {Backend} from "@generated-backend-types";
import AuthenticatedUser = Backend.App.Http.Resources.Dashboard.Auth.AuthenticatedUser;
import {CoreModule} from "../../../core.module";
import {NgxNavbarModule} from "ngx-bootstrap-navbar";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {RouterModule} from "@angular/router";
import {ContentHeaderComponent} from "../content-header/content-header.component";
import {BreadcrumbService} from "../../../../services/breadcrumb.service";
import {Breadcrumb} from "../../../../entities/breadcrumb.entity";
import { Location } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CoreModule, NgxNavbarModule, BsDropdownModule, RouterModule, ContentHeaderComponent],
    standalone: true
})
export class HeaderComponent implements OnInit {
  public title = 'Dashboard'
  public breadcrumbs: Breadcrumb[] = [];
  public user?: Partial<AuthenticatedUser>
  public locale: "de" | "en";

  public logout(): void {
    this.authService.logout().subscribe({})
  }

  public switchLang(lang: 'de' | 'en'): void {
    this.localeService.setLocale(lang)
  }

  public ngOnInit() {
    this.authService.getStoredUserInfo().subscribe({
      next: value => {
        this.user = value
        this.cdr.markForCheck()
      }
    })
    this.breadcrumbService.breadcrumbs$.subscribe({
      next: value => {
        this.breadcrumbs = value;
        this.cdr.markForCheck();
      }
    });
    this.titleService.title$.subscribe(
      (title) => {
        this.title = title;
        this.cdr.markForCheck()
      }
    )
  }

  public constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly authService: UserSessionService,
    private readonly titleService: TitleService,
    private readonly breadcrumbService: BreadcrumbService,
    readonly localeService: LocaleService,
    readonly location: Location,
  ) {
    this.locale = localeService.currentLocale
    localeService.localeChanged.subscribe(
      l => this.locale = l
    )
  }
}
